import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import WebsiteImage from 'components/WebsiteImage';
import Styles from 'components/Styles';

import { RichTextImageContainer } from './styles';

const RichTextImage = ({
  justifyDesktop,
  justifyMobile,
  styles,
  caption,
  link,
  'data-testid': dataTestId,
  ...otherProps
}) => {
  return (
    <RichTextImageContainer
      justifyDesktop={justifyDesktop}
      justifyMobile={justifyMobile}
      data-testid={dataTestId}
    >
      <Styles {...styles}>
        <WebsiteImage
          className="rich-text-image--image"
          style={{ bottom: 0, right: 0, height: 'auto' }}
          maxWidth="100%"
          {...otherProps}
          imgContainerStyle={{
            ...(otherProps?.imageSizes?.width && {
              width: '100%',
              maxWidth: `${otherProps.imageSizes.width}px`,
            }),
          }}
        />
      </Styles>
      {caption && caption.length > 0 && <p className="rich-text-image--caption">{caption}</p>}
      {link && <HyperLink className="img--link" href={link} />}
    </RichTextImageContainer>
  );
};

export default RichTextImage;
